<template>
  <div class="page page-invoices content">
    <h1 class="page__title">{{ str('invoices.menuTitle') }}</h1>
    <Invoices />
  </div>
</template>

<script>
  import Invoices from '@/components/settings/Invoices'

  export default {
    name: 'page-invoices',
    components: {
      Invoices,
    },
  }
</script>

<style lang="scss" scoped>
  .page-invoices {
    max-width: $content-page-width;
  }
</style>
